<template>
    <div>
        <compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData" :col="1"></compFormEdit>
        <div class="text-right">
            <Button type="primary" class="margin-right-10" @click="submit">保存</Button>
            <Button class="margin-right-15" @click="cancel">取消</Button>
        </div>
    </div>
</template>

<script>
import { HttpSaveCapacityOne, HttpGetAreaList, HttpGetCapacityOne } from '@/service/report';
export default {
    props:['type','activeid'],
    data(){
        return {
            formData:{},
            areaList:[],
        }
    },
    created(){
        HttpGetAreaList().then(res=>{
            this.areaList = res.data.map(item=>{
                return {
                    label:item.areaName,
                    value:item.id
                }
            })
        })
        if(this.type == 'add') return;

        HttpGetCapacityOne({
            id:this.activeid,
        }).then(res=>{
            this.formData = res.data
        })
    },
    computed:{
        getBase(){
            return [
                {
                    label: "区域",
                    key: 'areaId',
                    tag: 'Select',
                    options: this.areaList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "月份",
                    tag: 'DatePicker',
                    key: 'month',
                    props: {
                        style:"width:100%",
                        type:'month',
                        format:'yyyy-MM',
                        confirm: false,
                    },
                },
                {
                    label: '预计入库(cbm)',
                    key: "predictIn",
                    tag:'Input',
                    props:{
                        type:'number',
                    },
                    on:{
                        'on-blur':(val)=>{
                            if(Number(val.target.value)<0){
                                this.$Message.error('数值不能小于0！')
                            }
                        }
                    }
                },{
                    label: '预计出库(cbm)',
                    key: "predictOut",
                    tag:'Input',
                    props:{
                        type:'number',
                    },
                    on:{
                        'on-blur':(val)=>{
                            if(Number(val.target.value)<0){
                                this.$Message.error('数值不能小于0！')
                            }
                        }
                    }
                }
            ]
        }
    },
    methods:{
        submit(){
            if(this.formData.predictIn<0 || this.formData.predictOut<0 ){
                this.$Message.error('数值不能小于0！');
                return;
            }
            this.formData.month = this.handleDateFormat(this.formData.month, 'yyyy-mm');
            HttpSaveCapacityOne({
                ...this.formData
            }).then(res=>{
                this.$Message.success(res.message);
                this.$emit('on-update');
                this.cancel()
            },err=>{
                this.$Message.error({
                    content:err.message,
                    duration:10,
                    closable:true,
                })
            })
        },
        cancel(){
            this.$emit('on-close')
        }
    }
}
</script>